import script from "./DownloadCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCenter.vue?vue&type=script&setup=true&lang=js"

import "./DownloadCenter.vue?vue&type=style&index=0&id=cf7cdcee&lang=less&scoped=true"

import exportComponent from "/root/workspace/want-ceo-backstage-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf7cdcee"]])

export default __exports__